export * from './action-simple.component';
